<template>
  <select @change="switchLanguageSelector">
    <option
      v-for="sLocale in supportedLocales"
      :key="`locale-${sLocale}`"
      :value="sLocale"
      :selected="locale === sLocale"
    >
      {{ t(`locale.${sLocale}`) }}
    </option>
  </select>
</template>

<script>
  import { useI18n } from 'vue-i18n'
  import { useRouter } from "vue-router"
  import Tr from "@/translations"

  export default {
    setup() {
      const { t, locale } = useI18n()

      const supportedLocales = Tr.supportedLocales

      const router = useRouter()

      const switchLanguageSelector = async (event) => {
        const newLocale = event.target.value
        await Tr.switchLanguage(newLocale)
        try {
          // await router.replace({ params: { locale: newLocale } }) 
          await router.push(`/${newLocale}`)
        } catch(e) { 
          
          router.push("/")
        }
      }
      
      return { t, locale, supportedLocales, switchLanguageSelector }
    }
  }
</script>